import { default as React, useEffect, useContext, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import List from "./list";
import httpService from "core/infrastructure/http";
import { ShadowPricesDto, GetShadowPricesResponse, GetShadowPricesQuery } from "core/backend/data";
import SheetDataPart from "components/sheetDataPart";
import SheetHeader from "components/sheetHeader";
import { ApplicationState } from "core/app";
import { keys } from "ts-transformer-keys";
import { PageList } from "core/pages/pageList";

interface OwnState {
    applicationState: ApplicationState;
}
export const senderId = "shadowPrices";
export const page_config: PageList =
{
    apiUrl: "shadowPrices",
    webUrl: "shadowPrices",
    menu: "menu:menuShadowPrices",
    title: "menu:titleShadowPrices",
    apiType: "data",
    response: JSON.stringify(keys<GetShadowPricesResponse>()),
    dto: JSON.stringify(keys<ShadowPricesDto>()),
    parameters: JSON.stringify(keys<GetShadowPricesQuery>()),
    dateSteps: "H",
    getDefaultToDateTime: (applicationState: ApplicationState) => applicationState.getUntilFor1Hour()
};

type PageProps = OwnState & WithTranslation;

const Page = ({ t, applicationState }: PageProps) => {

    const initialResponse: GetShadowPricesResponse = { data: [], totalRows: 0, totalRowsWithFilter: 0, lastModifiedOn: "", appliedFilter: "", messages: [], rejected: false };
    const [response, setResponse] = useState(initialResponse);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [search, setSearch] = useState("");
    const [searchText, setSearchText] = useState("");
    const keysInDto = keys<ShadowPricesDto>().filter(f => f.startsWith("hub_"));

    useEffect(() => {
        (async function runAsync() {
            applicationState.handleInputAvailablilityChange(page_config.dateSteps, false, true, keysInDto);
            setLoading(true);
            setResponse(initialResponse);
            const response = await httpService.apiPost<GetShadowPricesResponse>({
                applicationState: applicationState,
                route: applicationState.apiService + "/" + page_config.apiType + "/" + page_config.apiUrl,

                query: {
                    FromUtc: applicationState.selectedDate.toISOString(),
                    ToUtc: applicationState.getUntilFor1Hour().toISOString(),
                    Filter: search, Skip: 0, Take: 1000
                },
                senderId: senderId
            })();

            if (response.ok) {
                setResponse(response.data);
                setError("");
                setLoading(false);
            } else if ((response.cancel || false) === false) {
                setError(response.error || t("common:UnknownError"));
                setLoading(false);
            }
        })();
    }, [applicationState.selectedDate, search]);

    const filteredData = response.data.filter(function (r: any) {
        return true;
        if (search === null) return true;
        if (search === "") return true;
        // @ts-ignore: Object is possibly 'null'.
        if (this.count > 50) return false;
        for (let name in r) if ((r[name] ?? "").toString().includes(search)) {
            // @ts-ignore: Object is possibly 'null'.
            this!.count++;
            return true;
        }
        return false;
    }, { count: 0 });

    return (
        <>
            <SheetHeader showDownload={true} applicationState={applicationState} title={t(page_config.title)} pageConfig={page_config} />
            <div className="subHeader">
                <div style={{ display: "inline-block" }}>
                    <div className="inputlabel">{t("page_Search")}</div>
                    <input className="inputTable" type="text" value={searchText}
                        onChange={(e) => setSearchText(e.currentTarget.value)}
                        onBlur={(e) => { setSearch(e.currentTarget.value); }}
                        onKeyDown={(e) => { if (e.keyCode === 13) e.currentTarget.blur(); }} />
                </div>
                <div style={{ display: "inline-block", marginLeft: "20px" }}>
                    <div className="inputlabel" style={{ margin: 0 }}>{t("common:totalWithoutFilter") + ": " + response.totalRows}</div>
                    <div className="inputlabel" style={{ margin: 0 }}>{t("common:totalWithFilter") + ": " + response.totalRowsWithFilter}</div>
                    <div className="inputlabel" style={{ margin: 0 }}>{t("common:displayedRows") + ": " + Math.min(applicationState.maxRows, response.totalRowsWithFilter)}</div>
                </div>
            </div>
            <SheetDataPart isLoading={isLoading} data={response.data} error={error}>
                <List data={filteredData.slice(0, applicationState.maxRows)} hubs={applicationState.selectedHubs.filter((f) => f.selected && f.isDisplayed)} />
            </SheetDataPart>
        </>
    );
};

export default withTranslation("page_shadowPrices")(Page);
